export default [
	{
		path: '/manage/fundtransfer',
		component: (resolve) => require(['../page.vue'], resolve),
		meta: {
			title: '资金上缴',
			authLogin: true,
		},
	},
	{
		path: '/manage/paymentRecords',
		component: (resolve) => require(['../pageRecord.vue'], resolve),
		meta: {
			title: '缴费记录',
			authLogin: true,
		},
	},
]